import logger from 'utils/logger.util';

const L = logger('owns');

// recommended, as per
// SEE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty
const objectHasOwn = Object.hasOwn;

// old way of doing things, from before Object.hasOwn
const objectHasOwnProperty = Function.prototype.call.bind(Object.prototype.hasOwnProperty);

// local version, shorter, uses the recommended approach, if available
const hasProp = objectHasOwn || objectHasOwnProperty;

const owns = (key, object) => {
  try {
    return !!hasProp(object, key);
  } catch (e) {
    L.warn('()', e);

    // return null instead of true/false, to signal it's an error
    return null;
  }
};

// noinspection JSUnusedGlobalSymbols
export default owns;
